import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import i18n from "src/i18n";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import { StepIndicatorCard } from "../../step-indicator-card";
import { SuppliersStep } from "./suppliers-step";
import { InventoryItemsStep } from "./inventory-items-step";

const FoodicsInventoryImportEdit = () => {
  const { t } = useTranslation("integrations");
  const navigate = useNavigate();
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const [currentStep, setCurrentStep] = useState(0);
  const isArabic = i18n.language === "ar";

  const handleFinish = () => {
    setNotifications([
      ...notifications,
      {
        type: "success",
        message: t("foodicsWorkspace.editImport.importFinished"),
      },
    ]);
    navigate("/integrations/foodics");
  };

  return (
    <Stack gap={3} p={{ xs: 2, sm: "8px 32px 32px 32px" }}>
      {/* Header */}
      <Box>
        <Button
          variant="text"
          startIcon={
            <ArrowBackIcon
              sx={{ transform: isArabic ? "scaleX(-1)" : "none" }}
            />
          }
          onClick={() => navigate("/integrations/foodics")}
          sx={{ color: "#667085" }}
        >
          {t("foodicsWorkspace.editImport.backToWorkspace")}
        </Button>
        <Typography fontSize={24} fontWeight={600} color="#101828" mt={1}>
          {t("foodicsWorkspace.editImport.title")}
        </Typography>
        <Typography fontSize={14} color="#667085">
          {t("foodicsWorkspace.editImport.subtitle")}
        </Typography>
      </Box>

      <Box bgcolor="#F2F4F7" width="100%" height="1px" />

      {/* Sub-step indicator */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        <StepIndicatorCard
          stepNumber={1}
          icon={<LocalShippingIcon />}
          title={t("foodicsWorkspace.editImport.suppliersStepTitle")}
          subtitle={t("foodicsWorkspace.editImport.suppliersStepSubtitle")}
          isActive={currentStep === 0}
          isCompleted={currentStep > 0}
        />
        <ChevronRightIcon
          sx={{
            color: "#98A2B3",
            display: { xs: "none", sm: "block" },
            transform: isArabic ? "scaleX(-1)" : "none",
          }}
        />
        <StepIndicatorCard
          stepNumber={2}
          icon={<Inventory2Icon />}
          title={t("foodicsWorkspace.editImport.itemsStepTitle")}
          subtitle={t("foodicsWorkspace.editImport.itemsStepSubtitle")}
          isActive={currentStep === 1}
          isCompleted={false}
        />
      </Stack>

      {/* Step content */}
      {currentStep === 0 ? (
        <SuppliersStep onContinue={() => setCurrentStep(1)} />
      ) : (
        <InventoryItemsStep
          onBack={() => setCurrentStep(0)}
          onFinish={handleFinish}
        />
      )}
    </Stack>
  );
};

export default FoodicsInventoryImportEdit;
